<template>
	<div class="products-type" v-clickoutside="hide">
		<div class="showValue" @click="openSelectBox">
      <span class="wordSpan">{{categories.name}}</span>
      <span class="iconBox" :class="[isShowSelectBox ? 'el-icon-caret-top' : 'el-icon-caret-bottom']"></span>  
    </div>
    <div class="selectBox" v-if="isShowSelectBox">
      <div class="top">
        <span :class="{'pre': index !== routerArray.length-1}" v-for="(router, index) in routerArray" @click="getCategories(router.id)"> {{index!==0?'>':''}} {{router.name}}</span>
      </div>
      <div class="content">
        <span class="empty" v-if="categoryList.length===0">该分类下暂无子分类</span>
        <el-radio-group v-else v-model="radio" @change="changeCategory">
          <el-radio :label="category" v-for="category in categoryList" :key="category.id">
            <span @click="getCategories(category.id)">{{category.name}}</span>
          </el-radio>
        </el-radio-group>
      </div>
      <div class="bottom">
        <el-button type="text" @click="allCategories">全部</el-button>
        <div class="bottomBtn">
          <el-button type="text" @click="isShowSelectBox = false">确定</el-button>
          <el-button type="text" @click="hide('abolish')">取消</el-button>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
  import * as api from 'src/api'
  import Clickoutside from 'element-ui/lib/utils/clickoutside'

  export default {
    created () {
      this.getCategories(0)
    },
    props: {
      like: {
        type: String
      }
    },
    data () {
      return {
        categories: {
          'name': '全部分类',
          'id': 0
        },
        radio: {},
        isShowSelectBox: false,
        categoryList: [],
        routerArray: [],
        abolish: false,
        preCategories: {}
      }
    },
    computed: {
    },
    methods: {
      // 获取分类
      getCategories (id) {
        this.categoryList = []
        this.$nextTick(() => {
          let url = '/product/categoryAjax.do'
          let params = {
            id: id
          }
          api.post(url, params, (data) => {
            this.categoryList = data.categoryList
            this.routerArray = data.routerArray
            this.categories = this.routerArray[this.routerArray.length - 1]
            if (this.radio.id !== id) {
              this.radio = {
                'name': '全部分类',
                'id': 0
              }
            }
          })
        })
      },
      openSelectBox () {
        if (this.isShowSelectBox === false) {
          this.isShowSelectBox = true
          this.preCategories = JSON.parse(JSON.stringify(this.categories))
        } else {
          this.isShowSelectBox = false
        }
      },
      changeCategory () {
        this.categories = this.radio
      },
      hide (type) {
        if (type === 'abolish') {
          this.abolish = true
        }
        this.isShowSelectBox = false
      },
      allCategories () {
        this.categories = {
          'name': '全部分类',
          'id': 0
        }
        this.isShowSelectBox = false
      }
    },
    components: {
    },
    filters: {
    },
    watch: {
      // 详情页监听的窗口关闭事件
      isShowSelectBox () {
        if (this.isShowSelectBox === false) {
          if (!this.abolish) {
            this.$emit('refresh', this.like, this.categories.id)
          } else {
            this.categories = this.preCategories
            this.abolish = false
          }
        } else {
          this.getCategories(this.categories.id)
        }
        this.radio = {}
      }
    },
    directives: { Clickoutside }
  }
</script>
<style type="text/css" lang="less" scoped>
  .products-type {
    position: relative;
    .showValue {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 140px;
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      border: 1px solid #bfcbd9;
      border-radius: 2px;
      cursor: pointer;
      box-sizing: border-box;
      font-size: 13px;
      color: #666666;
      background:#fff;
      span.wordSpan{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      span.iconBox{color:rgb(191, 203, 217)}
    }
    .selectBox {
      position: absolute;
      top: 35px;
      left: 0;
      width: 218px;
      padding: 0 15px;
      border: 1px solid #d8d8d8;
      border-radius: 2px;
      background: #fff;
      z-index: 100;
      font-size: 13px;
      .top {
        min-height: 39px;
        line-height: 39px;
        border-bottom: 1px solid #d8d8d8;
        white-space: nowrap;
        overflow: hidden;
        overflow-x: auto;
        .pre {
          color: #008cee;
          cursor: pointer;
        }
      }
      .content {
        position: relative;
        height: 200px;
        padding: 10px 0;
        overflow: auto;
        .empty{
          display: block;
          text-align: center;
        }
        .el-radio {
          display: block;
          padding: 0 0 10px 0;
          margin: 0;
        }
        .el-radio__label{font-size:13px;}
      }
      .bottom {
        height: 40px;
        border-top: 1px solid #d8d8d8;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .bottomBtn .el-button:nth-of-type(2){color:#666;}
      } 
    }
  }
</style>


// WEBPACK FOOTER //
// products-type.vue?12c3426d